// extracted by mini-css-extract-plugin
export default {"WebhookSaveForm-save":"WebhookSaveForm-save1-53Rk3J7TYb"};